/* main */
const UPDATE_EMPNO = 'main/UPDATE_EMPNO';
const UPDATE_DATE = 'main/UPDATE_DATE';
const UPDATE_SELF_EXCEPT_DATE = 'main/UPDATE_SELF_EXCEPT_DATE';
const UPDATE_SELF_EXCEPT_HOUR = 'main/UPDATE_SELF_EXCEPT_HOUR';
const UPDATE_SELF_EXCEPT_MINUTE = 'main/UPDATE_SELF_EXCEPT_MINUTE';
const GET_GOHOME_DATA = 'main/GET_GOHOME_DATA';
const SET_GOHOME_DATA = 'main/SET_GOHOME_DATA';
const SET_GOHOME_DATA_MONTHLY_ALL = 'main/SET_GOHOME_DATA_MONTHLY_ALL';
const OPEN_ADD_EXCEPT = 'main/OPEN_ADD_EXCEPT';
const CLOSE_ADD_EXCEPT = 'main/CLOSE_ADD_EXCEPT';
const SET_MONTHLY_WORK_TIME = 'main/SET_MONTHLY_WORK_TIME';
const SET_MONTHLY_REQUIRED_WORK_TIME = 'main/SET_MONTHLY_REQUIRED_WORK_TIME';
const OPEN_MODIFY_TIME = 'main/OPEN_MODIFY_TIME';
const CLOSE_MODIFY_TIME = 'main/CLOSE_MODIFY_TIME';
const OPEN_SAVE_ATTENDANCE = 'main/OPEN_SAVE_ATTENDANCE';
const CLOSE_SAVE_ATTENDANCE = 'main/CLOSE_SAVE_ATTENDANCE';
const UPDATE_MODIFY_TIME_HOUR = 'main/UPDATE_MODIFY_TIME_HOUR';
const UPDATE_MODIFY_TIME_MINUTE = 'main/UPDATE_MODIFY_TIME_MINUTE';
const SET_WORKHOME_PART_DATA = 'main/SET_WORKHOME_PART_DATA';
const OPEN_MODIFY_TIME_EX = 'main/OPEN_MODIFY_TIME_EX';
const CLOSE_MODIFY_TIME_EX = 'main/CLOSE_MODIFY_TIME_EX';
const UPDATE_MODIFY_TIME_EX = 'main/UPDATE_MODIFY_TIME_EX';

export default {
  UPDATE_EMPNO,
  UPDATE_DATE,
  UPDATE_SELF_EXCEPT_DATE,
  UPDATE_SELF_EXCEPT_HOUR,
  UPDATE_SELF_EXCEPT_MINUTE,
  GET_GOHOME_DATA,
  SET_GOHOME_DATA,
  SET_GOHOME_DATA_MONTHLY_ALL,
  OPEN_ADD_EXCEPT,
  CLOSE_ADD_EXCEPT,
  SET_MONTHLY_WORK_TIME,
  SET_MONTHLY_REQUIRED_WORK_TIME,
  OPEN_MODIFY_TIME,
  CLOSE_MODIFY_TIME,
  OPEN_SAVE_ATTENDANCE,
  CLOSE_SAVE_ATTENDANCE,
  UPDATE_MODIFY_TIME_HOUR,
  UPDATE_MODIFY_TIME_MINUTE,
  SET_WORKHOME_PART_DATA,
  OPEN_MODIFY_TIME_EX,
  CLOSE_MODIFY_TIME_EX,
  UPDATE_MODIFY_TIME_EX
}



// WEBPACK FOOTER //
// ./src/actions/mainTypes.js